export default "https://fiverr-res.cloudinary.com/npm-assets/@fiverr/search_perseus/game_trailers.23f3dd4.svg";